import React from "react";
import { useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { PATHS } from "configs/routeConfig";
import { Badge, Button } from "react-bootstrap";
import { useProfileHook } from "hooks/profile/useProfileHook";
import { getFormattedDateTimeWithTimezone } from "utils/functions";
import PropTypes from "prop-types";

function VisitDetailsCanvas(props) {
  const {
    showPermission,
    setShowPermission,
    type,
    onNavigateToAssessment = () => {},
    onClose,
    woundDetailsList,
    PatientDetails,
  } = props;

  const navigate = useNavigate();
  const { globalConfigData } = useProfileHook();

  const handleAssessment = (id) => {
    navigate(`/${PATHS.WOUND_LISTING}/${PATHS.WOUND_DETAILS}/${id}`);
  };

  const handleClose = () => {
    setShowPermission(false);
    if (onClose) {
      onClose();
    }
  };

  const anotherFunction = (id) => {
    navigate(`/${PATHS.WOUND_LISTING}/${PATHS.ASSESSMENT_DETAILS}/${id}`);
  };
  const WoundData = (id) => {
    const woundDetail = woundDetailsList?.woundList?.find((wound) => wound?._id === id);
    if (woundDetail) {
      sessionStorage.setItem("selectedWoundDetails", JSON.stringify(woundDetail));
    }
  };
  return (
    <Offcanvas show={showPermission} placement="end" className="offcanvas-size-40" onHide={handleClose}>
      <Offcanvas.Header closeButton className="align-items-end">
        <div className="d-flex flex-column">
          <Offcanvas.Title>{PatientDetails?.patientName}</Offcanvas.Title>
          <div className="d-flex flex-row text-gray fs-12">
            <span>ID: {PatientDetails?.patientBaseId} </span>
            <span>
              {" "}
              <span className="line-divider"></span> DOB :{" "}
              {getFormattedDateTimeWithTimezone(
                PatientDetails?.patientDob,
                globalConfigData?.data?.timeZone,
                globalConfigData?.data?.dateFormat,
                globalConfigData?.data?.timeFormat,
                false
              )}
            </span>
            <span>
              <span className="line-divider"></span> {PatientDetails?.patientGender}
            </span>
          </div>
        </div>
        <span className="text-gray fs-12">
          Last Visit:{" "}
          {getFormattedDateTimeWithTimezone(
            PatientDetails?.lastVisit || PatientDetails?.visitDate,
            globalConfigData?.data?.timeZone,
            globalConfigData?.data?.dateFormat,
            globalConfigData?.data?.timeFormat,
            false
          )}
        </span>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ul className="wound-list-outer">
          {type === "wound" && (
            <>
              <h5 className="mb-0 fs-16 fw-600">Wound Listing</h5>
              {woundDetailsList?.woundList?.length > 0 ? (
                woundDetailsList.woundList.map((el, index) => (
                  <li
                    className="cursor-pointer"
                    key={index}
                    onClick={() => {
                      handleAssessment(el?._id);
                      WoundData(el?._id);
                    }}
                  >
                    <div className="wound-details-list">
                      <span className="counter">{index + 1}</span>
                      <div className="wound-name-details">
                        <div className="d-flex align-items-center mb-4">
                          <h5 className="mb-0">
                            {el.title} | {el.masterEtiology?.title}
                          </h5>
                          <div className="ms-6">
                            {el.tag === "New" && (
                              <svg
                                width="35"
                                height="17"
                                viewBox="0 0 35 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M34.5889 13.222L30.509 8.22215L34.5089 3.32231C34.7277 3.05426 34.8655 2.7294 34.9062 2.38581C34.947 2.04222 34.8889 1.69414 34.7389 1.38237C34.5869 1.03292 34.3349 0.736287 34.0146 0.52986C33.6942 0.323433 33.32 0.216454 32.939 0.222407H1.93994C1.68911 0.218437 1.43996 0.263917 1.20672 0.356249C0.973471 0.448582 0.760699 0.585959 0.580553 0.760533C0.400407 0.935108 0.256416 1.14346 0.156803 1.37369C0.0571908 1.60392 0.00390873 1.85152 0 2.10235L0 14.352C0.0105104 14.8568 0.220494 15.3369 0.584031 15.6873C0.947568 16.0377 1.43507 16.2299 1.93994 16.2219H33.0489C33.4172 16.2281 33.7796 16.1287 34.0932 15.9356C34.4068 15.7424 34.6586 15.4636 34.8189 15.1319C34.9628 14.8239 35.0175 14.4817 34.9769 14.1441C34.9362 13.8065 34.8018 13.4871 34.5889 13.222ZM1.99994 14.222V2.22234H32.779L27.9391 8.15216L32.849 14.222H1.99994Z"
                                  fill="#EEE417"
                                />
                                <path
                                  d="M9.38595 9.57179L6.12606 5.22192H4.99609V11.4017H6.12606V7.06187L9.38595 11.4017H10.5059V5.22192H9.38595V9.57179Z"
                                  fill="#EEE417"
                                />
                                <path
                                  d="M12.1797 11.4017H16.8395V10.3818H13.3097V8.77181H16.4995V7.74184H13.3097V6.25189H16.8395V5.22192H12.1797V11.4017Z"
                                  fill="#EEE417"
                                />
                                <path
                                  d="M24.5201 9.65178L23.0601 5.22192H21.8402L20.3702 9.65178L19.0503 5.22192H17.8203L19.7803 11.4017H20.8902L22.4502 6.81187L24.0001 11.4017H25.1301L27.08 5.22192H25.8501L24.5201 9.65178Z"
                                  fill="#EEE417"
                                />
                              </svg>
                            )}
                            {el.tag === "Request Closure" && (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M8.5 3.5C8.5 3.10218 8.65804 2.72064 8.93934 2.43934C9.22064 2.15804 9.60218 2 10 2H14C14.3978 2 14.7794 2.15804 15.0607 2.43934C15.342 2.72064 15.5 3.10218 15.5 3.5H17C17.3978 3.5 17.7794 3.65804 18.0607 3.93934C18.342 4.22064 18.5 4.60218 18.5 5V12.5H17.5V5C17.5 4.86739 17.4473 4.74021 17.3536 4.64645C17.2598 4.55268 17.1326 4.5 17 4.5H15.5C15.5 4.89782 15.342 5.27936 15.0607 5.56066C14.7794 5.84196 14.3978 6 14 6H10C9.60218 6 9.22064 5.84196 8.93934 5.56066C8.65804 5.27936 8.5 4.89782 8.5 4.5H7C6.86739 4.5 6.74021 4.55268 6.64645 4.64645C6.55268 4.74021 6.5 4.86739 6.5 5V19C6.5 19.1326 6.55268 19.2598 6.64645 19.3536C6.74021 19.4473 6.86739 19.5 7 19.5H13V20.5H7C6.60218 20.5 6.22064 20.342 5.93934 20.0607C5.65804 19.7794 5.5 19.3978 5.5 19V5C5.5 4.60218 5.65804 4.22064 5.93934 3.93934C6.22064 3.65804 6.60218 3.5 7 3.5H8.5ZM10 3C9.86739 3 9.74021 3.05268 9.64645 3.14645C9.55268 3.24021 9.5 3.36739 9.5 3.5V4.5C9.5 4.63261 9.55268 4.75979 9.64645 4.85355C9.74021 4.94732 9.86739 5 10 5H14C14.1326 5 14.2598 4.94732 14.3536 4.85355C14.4473 4.75979 14.5 4.63261 14.5 4.5V3.5C14.5 3.36739 14.4473 3.24021 14.3536 3.14645C14.2598 3.05268 14.1326 3 14 3H10ZM11.5 8V9.5H10V10.5H11.5V12H12.5V10.5H14V9.5H12.5V8H11.5ZM14 13.5C13.8674 13.5 13.7402 13.5527 13.6464 13.6464C13.5527 13.7402 13.5 13.8674 13.5 14V17.3945C13.5 17.9707 13.6423 18.5379 13.9142 19.0459C14.186 19.5539 14.5791 19.9869 15.0585 20.3065L16.7225 21.4165C16.8047 21.4713 16.9012 21.5006 17 21.5006C17.0988 21.5006 17.1953 21.4713 17.2775 21.4165L18.9415 20.3065C19.4208 19.9869 19.8139 19.554 20.0857 19.0461C20.3576 18.5382 20.4999 17.9711 20.5 17.395V14C20.5 13.8674 20.4473 13.7402 20.3536 13.6464C20.2598 13.5527 20.1326 13.5 20 13.5H14ZM18.8535 16.3535L16.8535 18.3535C16.7597 18.4472 16.6326 18.4999 16.5 18.4999C16.3674 18.4999 16.2403 18.4472 16.1465 18.3535L15.1465 17.3535L15.8535 16.6465L16.5 17.293L18.1465 15.6465L18.8535 16.3535Z"
                                  fill="#6362E6"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                        <ul className="list-item">
                          <li>
                            Established on:{" "}
                            {getFormattedDateTimeWithTimezone(
                              el.visitDate,
                              globalConfigData?.data?.timeZone,
                              globalConfigData?.data?.dateFormat,
                              globalConfigData?.data?.timeFormat,
                              false
                            )}
                          </li>
                        </ul>
                        <ul className="list-item">
                          {el.assessments?.length > 0 && (
                            <li>
                              {!el.assessments[el?.assessments?.length - 1]?.isWoundAssessed && (
                                <span className="text-danger">
                                  {el?.assessments[el.assessments?.length - 1]?.comment}
                                </span>
                              )}
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                    <div className="wound-list-right-part">
                      <div className="d-flex gap-6">
                        {el.adminAction === "Needs Review" && (
                          <Badge className="warning-light fs-12 lh-1-25">{el?.adminAction}</Badge>
                        )}
                        {el.adminAction === "Approved" && (
                          <Badge className="success-light fs-12 lh-1-25">{el?.adminAction}</Badge>
                        )}
                        {el.adminAction === "Not Assessed" && (
                          <Badge className="danger-light fs-12 lh-1-25">{el?.adminAction}</Badge>
                        )}
                        {el.status === "Healed" && <Badge className="success-light fs-12 lh-1-25">{el?.status}</Badge>}
                        {el.status === "Active" && <Badge className="primary-light fs-12 lh-1-25">{el?.status}</Badge>}
                        {el.status === "Re-active" && (
                          <Badge className="warning-light fs-12 lh-1-25">{el?.status}</Badge>
                        )}
                      </div>
                      <div className="d-flex align-items-center gap-6">
                        {/* <Button
                          variant=""
                          className="btn-icon m-0 link-dark"
                          onClick={() => {
                            handleAssessment(el?._id);
                            WoundData(el?._id);
                          }}
                        >
                          <span className="inic inic-eye"></span>
                        </Button> */}
                        <Button
                          variant=""
                          className="btn-icon m-0 link-dark w-18"
                          onClick={() => {
                            handleAssessment(el?._id);
                            WoundData(el?._id);
                          }}
                        >
                          <span className="inic inic-right-arrow"></span>
                        </Button>
                      </div>
                    </div>
                  </li>
                ))
              ) : (
                <div className="text-center p-4 text-muted">
                  <p>No wounds created yet</p>
                </div>
              )}
            </>
          )}
          {type === "assessment" && (
            <>
              <h5 className="mb-0 fs-16 fw-600">Assessment Listing</h5>
              {woundDetailsList?.assessments?.length > 0 ? (
                woundDetailsList.assessments?.map((el, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      onNavigateToAssessment();
                      anotherFunction(el._id);
                    }}
                    className="cursor-pointer"
                  >
                    <div className="wound-details-list">
                      <span className="counter">{index + 1}</span>
                      <div className="wound-name-details">
                        <div className="d-flex">
                          <h5>Assessment</h5>
                          <h5 className="ms-6">{el.index + 1}</h5>
                        </div>
                        <ul className="list-item">
                          <li>
                            Visit Date:
                            {getFormattedDateTimeWithTimezone(
                              el.visitDate,
                              globalConfigData?.data?.timeZone,
                              globalConfigData?.data?.dateFormat,
                              globalConfigData?.data?.timeFormat,
                              false
                            )}
                          </li>
                        </ul>
                        <ul className="list-item">
                          <li>{!el?.isWoundAssessed && <span className="text-danger">{el?.comment}</span>}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-6">
                      <div className="wound-list-right-part">
                        {el.adminAction === "Needs Review" && (
                          <Badge className="warning-light fs-12 lh-1-25">{el?.adminAction}</Badge>
                        )}
                        {el.adminAction === "Approved" && (
                          <Badge className="success-light fs-12 lh-1-25">{el?.adminAction}</Badge>
                        )}
                        {el.adminAction === "Not Assessed" && (
                          <Badge className="danger-light fs-12 lh-1-25">{el?.adminAction}</Badge>
                        )}
                      </div>
                      <Button
                        variant=""
                        className="btn-icon m-0 link-dark"
                        onClick={() => {
                          onNavigateToAssessment();
                          anotherFunction(el._id);
                        }}
                      >
                        <span className="inic inic-right-arrow"></span>
                      </Button>
                    </div>
                  </li>
                ))
              ) : (
                <div className="text-center p-4 text-muted">
                  <p>No assessments created yet</p>
                </div>
              )}
            </>
          )}
        </ul>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

VisitDetailsCanvas.propTypes = {
  onClose: PropTypes.func.isRequired,
  showPermission: PropTypes.bool.isRequired,
  setShowPermission: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  onNavigateToAssessment: PropTypes.func,
  setsWoundId: PropTypes.func.isRequired,
  woundDetailsList: PropTypes.object.isRequired,
  PatientDetails: PropTypes.object.isRequired,
};

export default VisitDetailsCanvas;
